<table>
    <tr>
        <th></th>
        <th>Username</th>
        <th>ETH account</th>
        <th>Position</th>
        <th>Avatar</th>
        <th>Balance</th>
    </tr>
    <tr *ngFor="let player of _players">
        <td *ngIf="_nextPlayer == player; else emptyCell">NEXT--></td>
        <ng-template #emptyCell>
            <td></td>
        </ng-template>
        <td>{{_playersMap.get(player).username}}</td>
        <td>{{_playersMap.get(player).address}}</td>
        <td>{{_playersMap.get(player).position}}</td>
        <td>{{_playersMap.get(player).avatar}}</td>
        <td>{{_playersMap.get(player).balance}}</td>
    </tr>
</table>